<template v-if="showUserBind">
  <div>
    <Spin fix v-show="isSpinShow" size="large" />
    <div>
      <input
        id="upload_file"
        type="file"
        style="display: none;"
        accept="image/*"
        capture="camcorder"
        name="file"
        @change="fileChange($event)"
      />
      <!-- <div id="upload_warp_left" style="margin:10px" onclick="$('#upload_file').click();">
          <img style="height:200px" :src="iacardImg" />
        </div>-->
      <div id="upload_warp_left" style="margin:10px">
        <img style="height:200px" :src="iacardImg" />
      </div>
      <!--Input placeholder="请上传身份证件照" v-model="idCard" style="width: auto">
                    <Icon type="ios-card-outline" slot="prefix" />
        </Input-->
      <div v-if="true" style="text-align:center;">
        <Row>
          <Col span="8" style="text-align:right;">绑定类型：</Col>
          <Col span="12" style="text-align:left;">
            <Select v-model="bindCondition">
              <Option value="householder">户主用户</Option>
              <Option value="nothouseholder">非户主用户</Option>
              <Option value="personnel">工程人员</Option>
            </Select>
          </Col>
        </Row>
      </div>

      <div
        style="margin-top: 10px"
        v-if="bindCondition == 'householder' || bindCondition == 'personnel'"
      >
        <Row>
          <Col span="8" style="text-align:right;">证件号码：</Col>
          <Col span="12" style="text-align:left;">
            <Input v-model="idCard" placeholder="请输入证件号"></Input>
          </Col>
        </Row>
      </div>

      <div v-if="bindCondition == 'nothouseholder'" style="margin-top: 10px">
        <Row>
          <Col span="8" style="text-align:right;">设备编号：</Col>
          <Col span="12" style="text-align:left;">
            <Input v-model="meterId" placeholder="请输入设备编号"></Input>
          </Col>
          <!-- <Col span="8" style="text-align:left;">
              <Button style="float: left" onclick="$('#code').click();">识别条形码图片</Button>
              <input
                id="code"
                class="pad10 b-f"
                style="display: none;"
                type="file"
                capture="camcorder"
                accept="image/*"
                @change="onClickInputFile"
              />
            </Col> -->
        </Row>
      </div>

      <div v-if="isShowData" style="text-align:center">
        <Row>
          <Col span="8" style="text-align:right;">姓名：</Col>
          <Col span="16" style="text-align:left;">{{ userData.name }}</Col>
        </Row>
        <Row>
          <Col span="8" style="text-align:right;">性别：</Col>
          <Col span="16" style="text-align:left;">{{ userData.sex }}</Col>
        </Row>
        <Row>
          <Col span="8" style="text-align:right;">民族：</Col>
          <Col span="16" style="text-align:left;">{{ userData.nation }}</Col>
        </Row>
        <Row>
          <Col span="8" style="text-align:right;">生日：</Col>
          <Col span="16" style="text-align:left;">{{ userData.birth }}</Col>
        </Row>
        <Row>
          <Col span="8" style="text-align:right;">住址：</Col>
          <Col span="16" style="text-align:left;">{{ userData.address }}</Col>
        </Row>
      </div>
      <Button
        style="margin-top:20px"
        :loading="isCommiting"
        :disabled="false"
        long
        @click="bindUser()"
        type="success"
        >确认信息并提交绑定</Button
      >
    </div>
  </div>
</template>

<script>
export default {
  props: {
    callBack: {
      type: Function
    }
  },
  name: "cameras-and-albums",
  data() {
    return {
      bindCondition: "householder",
      isShowData: false,
      isSpinShow: false,
      isDisabled: true,
      isCommiting: false,
      height: document.body.clientHeight,
      width: document.body.clientWidth,
      iacardImg: require("../../assets/imgs/idcard.jpg"),
      idCard: "",
      meterId: "",
      userData: {},
      showUserBind: true
    };
  },
  methods: {
    onClickInputFile(param) {
      let that = this;
      that.isSpinShow = true;
      if (param.target.files) {
        // 压缩文件
        lrz(param.target.files[0])
          .then(function(rst) {
            console.log(rst);
            that.imgBarCode = rst.base64;
            that.scanBarCode(rst.base64);
          })
          .catch(function(error) {
            //失败时执行
          })
          .always(function() {
            //不管成功或失败，都会执行
          });
      }
    },
    scanBarCode(base64) {
      let that = this;
      Quagga.decodeSingle(
        {
          //解码方式，与条形码的编码方式有关
          decoder: {
            readers: ["code_128_reader"]
          },
          numOfWorkers: 0,
          locate: true, // try to locate the barcode in the image
          src: base64 // or 'data:image/jpg;base64,' + data
        },
        function(result) {
          that.isSpinShow = false;
          console.log(result);
          if (result) {
            if (result.codeResult) {
              this.meterId = result.codeResult.code;
              // $("#result").val(result.codeResult.code);
            } else {
              alert("条码格式错误，请使用Code128条码！");
              $("#result").val("");
            }
          } else {
            alert("未扫码成功，请重新扫码!");
            $("#result").val("");
          }
        }
      );
    },
    bindUser() {
      if (this.idCard.length != 18 && this.bindCondition != "nothouseholder") {
        this.$Modal.error({
          title: "提示",
          content: "请输入正确的身份证号！"
        });
        return;
      }

      if (this.meterId.length != 14 && this.bindCondition == "nothouseholder") {
        this.$Modal.error({
          title: "提示",
          content: "请输入正确的设备编号！"
        });
        return;
      }

      this.isSpinShow = true;
      this.isCommiting = true;
      var that = this;
      console.log(that.idCard);
      $.ajax({
        url: "/api/userBind",
        contentType: "application/json",
        type: "post",
        data: JSON.stringify({
          idCard: that.idCard,
          bindType: that.bindCondition,
          openId: that.openId,
          meterId: that.meterId
        }),
        dataType: "json",
        success: function(data) {
          if (data.errorCode != 0) {
            that.$Modal.error({
              title: "提示",
              content: data.errorInfo
            });
            return;
          } else {
            // 当前用户微信未进行绑定
            that.$Modal.success({
              title: "提示",
              content: "用户绑定成功"
            });
            that.callBack(data);
          }
          console.log(data);
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口调用异常"
          });
        },
        complete: function(XMLHttpRequest, textStatus) {
          that.isCommiting = false;
          that.isSpinShow = false;
        }
      });
    },
    fileChange(param) {
      let that = this;
      if (param.target.files) {
        // 压缩文件
        lrz(param.target.files[0])
          .then(function(rst) {
            console.log(rst);
            that.idcardocr(rst.base64);
          })
          .catch(function(error) {
            //失败时执行
          })
          .always(function() {
            //不管成功或失败，都会执行
          });
      }
    },
    idcardocr(base64) {
      const signature = require("../../utils/signature.js");
      //0代表身份证正面
      let param = signature.create_idcard_param(base64.split(";base64,")[1], 0);
      let that = this;
      that.isSpinShow = true;
      that.isDisabled = true;
      that.isShowData = false;
      $.ajax({
        url: "/api/idCardOCR",
        contentType: "application/json",
        type: "post",
        data: param,
        dataType: "json",
        success: function(receiveData) {
          if (receiveData.ret != 0) {
            that.$Notice.error({
              title: "异常" + receiveData.ret,
              desc: receiveData.msg
            });
            that.isSpinShow = false;
            that.iacardImg = require("../../assets/imgs/idcard.jpg");
            that.userData = {};
            that.idCard = "";
            return;
          }
          that.iacardImg =
            "data:image/jpg;base64," + receiveData.data.frontimage;
          that.userData = receiveData.data;
          that.idCard = that.userData.id;
          that.isSpinShow = false;
          that.isDisabled = false;
          that.isShowData = true;
        },
        error: function(textStatus) {
          that.$Notice.error({
            title: "异常",
            desc: "接口请求异常"
          });
        }
      });
    }
  }
};
</script>
